import StatusBadge from "./StatusBadge";
import { ServiceProvider } from "../../../utils/integrationConfigData";
import { getProviderStatusTone, toTitleCase } from "../../../utils/Utils";

interface ServiceProviderTableProps {
  providers: ServiceProvider[];
  onRowClick?: (provider: ServiceProvider) => void;
  onEditClick?: (provider: ServiceProvider) => void;
}

const ServiceProviderTable = ({
  providers,
  onRowClick,
  onEditClick,
}: ServiceProviderTableProps) => {
  return (
    <div className="ic-table-wrap">
      <div className="table-responsive">
        <table className="table ic-table mb-0">
          <thead>
            <tr>
              <th>Service Provider</th>
              <th>CRD</th>
              <th>DTR</th>
              <th>PAS</th>
              <th>CPT Codes</th>
              <th>Status</th>
              <th className="ic-table-actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {providers.length === 0 ? (
              <tr className="ic-table-empty-row">
                <td colSpan={6} className="ic-table-empty">
                  No service provider found
                </td>
              </tr>
            ) : (
              providers.map((provider) => (
                <tr
                  key={provider.id}
                  className="ic-table-row"
                  onClick={() => onRowClick?.(provider)}
                >
                  <td>
                    <div className="ic-provider-cell">
                      <div className="ic-provider-name">{provider.name}</div>
                      <div className="ic-provider-path">{provider.path}</div>
                    </div>
                  </td>
                  <td>
                    <StatusBadge status={provider.crd} />
                  </td>
                  <td>
                    <StatusBadge status={provider.dtr} />
                  </td>
                  <td>
                    <StatusBadge status={provider.pas} />
                  </td>
                  <td>
                    <div className="ic-cpt-count">{provider.cptCodes}</div>
                  </td>
                  <td>
                    <div
                      className={`ic-provider-status-chip ic-provider-status-${getProviderStatusTone(provider.status)}`}
                    >
                      <span className="ic-provider-meta-value">{toTitleCase(provider.status)}</span>
                    </div>
                  </td>
                  <td className="ic-table-actions-cell">
                    <button
                      type="button"
                      className="btn btn-link ic-table-edit-btn"
                      aria-label={`Edit ${provider.name}`}
                      title="Edit provider details"
                      onClick={(event) => {
                        event.stopPropagation();
                        onEditClick?.(provider);
                      }}
                    >
                      <i className="fh_create" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceProviderTable;
